import moment from "moment";
import { Modules } from "../common/constants/sidebar";
import { DATE_FIELD_FORMAT } from "../common/constants/extra-constants";

export function createData(
  Id,
  ClientName,
  ClientLocation,
  Currency,
  MsaStartDate,
  MsaEndDate,
  VeersaBusinessOwner,
  PaymentTerms,
  VeersaDeliveryOfficer,
  MsaAttachment
) {
  return {
    Id,
    ClientName,
    ClientLocation,
    Currency,
    MsaStartDate,
    MsaEndDate,
    VeersaBusinessOwner,
    PaymentTerms,
    VeersaDeliveryOfficer,
    MsaAttachment,
  };
}

export const rows = [
  createData(
    "1",
    "Arvind",
    "USA",
    "Dollars",
    "10-August-2022",
    "04-October-2022",
    "Sudeb Mandal",
    "15 Days",
    "Rahul Gupta",
    "Attachment"
  ),
  createData(
    "2",
    "John Watson",
    "USA",
    "Dollars",
    "10-August-2022",
    "04-October-2022",
    "Sudeb Mandal",
    "15 Days",
    "Rahul Gupta",
    "Attachment"
  ),
  createData(
    "3",
    "John Watson",
    "USA",
    "Dollars",
    "10-August-2022",
    "04-October-2022",
    "Sudeb Mandal",
    "15 Days",
    "Rahul Gupta",
    "Attachment"
  ),
  createData(
    "4",
    "John Watson",
    "USA",
    "Dollars",
    "10-August-2022",
    "04-October-2022",
    "Sudeb Mandal",
    "15 Days",
    "Rahul Gupta",
    "Attachment"
  ),
  createData(
    "5",
    "John Watson",
    "USA",
    "Dollars",
    "10-August-2022",
    "04-October-2022",
    "Sudeb Mandal",
    "15 Days",
    "Rahul Gupta",
    "Attachment"
  ),
  createData(
    "6",
    "John Watson",
    "USA",
    "Dollars",
    "10-August-2022",
    "04-October-2022",
    "Sudeb Mandal",
    "15 Days",
    "Rahul Gupta",
    "Attachment"
  ),
  createData(
    "7",
    "John Watson",
    "USA",
    "Dollars",
    "10-August-2022",
    "04-October-2022",
    "Sudeb Mandal",
    "15 Days",
    "Rahul Gupta",
    "Attachment"
  ),
  createData(
    "8",
    "John Watson",
    "USA",
    "Dollars",
    "10-August-2022",
    "04-October-2022",
    "Sudeb Mandal",
    "15 Days",
    "Rahul Gupta",
    "Attachment"
  ),
  createData(
    "9",
    "John Watson",
    "USA",
    "Dollars",
    "10-August-2022",
    "04-October-2022",
    "Sudeb Mandal",
    "15 Days",
    "Rahul Gupta",
    "Attachment"
  ),
  createData(
    "10",
    "John Watson",
    "USA",
    "Dollars",
    "10-August-2022",
    "04-October-2022",
    "Sudeb Mandal",
    "15 Days",
    "Rahul Gupta",
    "Attachment"
  ),
  createData(
    "11",
    "Arvind",
    "USA",
    "Dollars",
    "10-August-2022",
    "04-October-2022",
    "Sudeb Mandal",
    "15 Days",
    "Rahul Gupta",
    "Attachment"
  ),
  createData(
    "12",
    "Arvind",
    "USA",
    "Dollars",
    "10-August-2022",
    "04-October-2022",
    "Sudeb Mandal",
    "15 Days",
    "Rahul Gupta",
    "Attachment"
  ),
  createData(
    "13",
    "Arvind",
    "USA",
    "Dollars",
    "10-August-2022",
    "04-October-2022",
    "Sudeb Mandal",
    "15 Days",
    "Rahul Gupta",
    "Attachment"
  ),
  createData(
    "14",
    "Arvind",
    "USA",
    "Dollars",
    "10-August-2022",
    "04-October-2022",
    "Sudeb Mandal",
    "15 Days",
    "Rahul Gupta",
    "Attachment"
  ),
];

export const dropDownMockData = {
  currency: ["USD", "INR", "EU", "EUR"],
  location: ["US", "UK", "IN"],
  businessOwner: ["Sudeb Mandal", "Rahul Gupta", "Vipul Taneja"],
  paymentTerms: ["consectetur", "consectetur"],
  deliveryOfficer: ["Rahul Gupta", "Vipul Taneja"],
  clientName: ['Duly', 'Pharma Code', 'Kipu'],
  projectManagerName: ['Amar', 'Sahil', 'Gaurav'], 
  employeeId: ['Arsalan', 'Arvind', 'Aditya'],
  projectName: ['duly', 'kipu'],
  billStatus: ['Billable', 'Shadow', 'NB - Backfilling','NB - Future SOW','NB - Additional Scope','NB - Productivity Gap','NB - Transition','NB - Internal','NB - Management'],
  site: ['Offshore', 'Onshore'],
  sowType: ['Fixed Price', 'Fixed Capacity', 'T&M - Hourly', 'T&M - Daily', 'T&M - Monthly'],
};

export const initialData = (headingName ,selectedPeriodWeek) => {
  switch(headingName) {
    case Modules.CLIENT_ADMIN:
      return {
        clientName: "",
        location: "",
        currency: "",
        msaStartDate: "",
        msaEndDate: "",
        businessOwner: "",
        paymentTerms: "",
        deliveryOfficer: "",
        msaDoc: "",
      };
    case Modules.PROJECT_ADMIN:
      return {
        projectName: '',
        clientName: '',
        type: '',
        sowStartDate: '',
        sowEndDate: '',
        projectManagerName: '',
        maxBillableCount: 0,
        approvers: []
      };
    case Modules.SOW:
      return {
        sowName: '',
        sowStartDate: null,
        sowEndDate: null,
        sowType: '',
        namedSOWFlag: false,
        status: '',
        note: '',
        active: true,
      };
    case Modules.PROJECT_ALLOCATION:
      return {
        employeeName: '',
        projectName: '',
        startDate: '',
        endDate: '',
        allocation: ''
      };
    case Modules.TIMESHEET:
      let dates = {};
      let date = moment(selectedPeriodWeek.startDate);
      for (let i=0;i<7;i++){
        dates[date.format('')] = "";
        date.add(1,'days');
      }
      return {
        projectName:'',
        task:'',
        notes:'',
        totalHrs:'',
        status:'',
        ...dates
      };
    case Modules.PROJECT_MANAGEMENT:
      return {
        employeeName: [],
        endDate: '',
        projectManagerName: '',
        projectName: '',
        startDate: '',
        status: '',
        sowId: null,
        sowName: ''
      };
    case Modules.INVOICE_TRACKER:
      return {
        clientName: '',
        projectName: '',
        createDate: moment().format(DATE_FIELD_FORMAT),
        billMonth: '',
        billStartDate: '',
        billEndDate: '',
        billAmount: '',
        revenueAmount: '',
        qbInvoiceReference: '',
        billAmountReceived: '',
        clientReminderDate: '',
        remark: '',
        invoiceStatus: '',
        billCurrency: '',
        revenueCurrency: ''
      }
    default:
      return {};
  }
};

export const timeSheetData = {
  data: [
    {
      "fieldId": 1,
      "projectName": "Duly",
      "task": "Development",
      "dateHours": [
        {
          "date": moment('20221114'),
          "hours": 2,
        },
        {
          "date": moment('20221114').add(1,'days'),
          "hours": 4,
        },
        {
          "date": moment('20221114').add(2,'days'),
          "hours": 1.2,
        },
        {
          "date": moment('20221114').add(3,'days'),
          "hours": 0,
        },
        {
          "date": moment('20221114').add(4,'days'),
          "hours": 2,
        },
        {
          "date": moment('20221114').add(5,'days'),
          "hours": 0,
        },
        {
          "date": moment('20221114').add(6,'days'),
          "hours": 1,
        }
      ],
      "totalHrs": 5
    },
    {
      "fieldId": 2,
      "projectName": "Duly",
      "task": "Development",
      "dateHours": [
        {
          "date": moment('20221114'),
          "hours": 2.1,
        },
        {
          "date": moment('20221114').add(1,'days'),
          "hours": 0,
        },
        {
          "date": moment('20221114').add(2,'days'),
          "hours": 3.2,
        },
        {
          "date": moment('20221114').add(3,'days'),
          "hours": 0.5,
        },
        {
          "date": moment('20221114').add(4,'days'),
          "hours": 1,
        },
        {
          "date": moment('20221114').add(5,'days'),
          "hours": 4,
        },
        {
          "date": moment('20221114').add(6,'days'),
          "hours": 0,
        }
      ],
      "totalHrs": 5
    }
  ],
  totalCount: 2
}

export const allTasks = [
  {
    taskName: "Define & Hypothesis",
    taskId:1,
  },
  {
    taskName:"Development",
    taskId:2,
  },
  {
    taskName:"Prototyping & Testing",
    taskId:3,
  },
  {
    taskName:"Design Review",
    taskId:4,
  },
  {
    taskName:"Visual Design",
    taskId:5,
  }
]